module.exports = __webpack_public_path__ + "static/media/logo-icon.f4d73201.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/logo-icon.png
// module id = 323
// module chunks = 0